'use strict';exports.__esModule = true;var _react = require('react');var _react2 = _interopRequireDefault(_react);
var _propTypes = require('prop-types');var _propTypes2 = _interopRequireDefault(_propTypes);
var _classnames = require('classnames');var _classnames2 = _interopRequireDefault(_classnames);
var _ShowMore = require('./ShowMore.scss');var _ShowMore2 = _interopRequireDefault(_ShowMore);function _interopRequireDefault(obj) {return obj && obj.__esModule ? obj : { default: obj };}function _classCallCheck(instance, Constructor) {if (!(instance instanceof Constructor)) {throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self, call) {if (!self) {throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call && (typeof call === "object" || typeof call === "function") ? call : self;}function _inherits(subClass, superClass) {if (typeof superClass !== "function" && superClass !== null) {throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);}subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } });if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;}var

ShowMore = function (_Component) {_inherits(ShowMore, _Component);function ShowMore() {var _temp, _this, _ret;_classCallCheck(this, ShowMore);for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {args[_key] = arguments[_key];}return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.
    state = {
      collapsed: false,
      acc: '',
      accBackup: '' }, _this.












    calcOptimizedText = function (text) {
      if (!text) {
        return '';
      }

      var rows = text.trim().split('\n');
      var acc = '';
      var accBackup = '';
      _this.overflow = false;

      for (var rowIndex = 0; rowIndex < rows.length; rowIndex += 1) {
        if (_this.overflow) break;

        var row = rows[rowIndex];
        var words = row.trim().split(' ');

        for (var wordIndex = 0; wordIndex < words.length; wordIndex += 1) {
          accBackup = acc;
          acc += (wordIndex ? ' ' : '') + words[wordIndex];
          _this.hidden.innerHTML = acc + ' <button>' + _this.props.moreButtonText + '...</button>';
          if (_this.hidden.clientHeight > _this.props.heightLimit) {
            _this.overflow = true;
            break;
          }
        }
        acc += '\n';
      }
      return _this.setState({ acc: acc, accBackup: accBackup });
    }, _this.

    closeAllText = function (event) {
      event.stopPropagation();
      _this.setState({ collapsed: false });
    }, _this.

    openAllText = function (event) {
      event.stopPropagation();
      _this.setState({ collapsed: true });
    }, _this.

    renderTranslateButton = function () {
      if (_this.overflow && _this.state.collapsed || !_this.overflow) {
        return _this.props.translateButton;
      }
      return null;
    }, _this.

    renderText = function () {var _this$props =









      _this.props,withoutEllipses = _this$props.withoutEllipses,hideMoreButton = _this$props.hideMoreButton,showHideButton = _this$props.showHideButton,moreButtonText = _this$props.moreButtonText,hideButtonText = _this$props.hideButtonText,heightLimit = _this$props.heightLimit,text = _this$props.text,withTextEllipses = _this$props.withTextEllipses;var _this$state =
      _this.state,collapsed = _this$state.collapsed,accBackup = _this$state.accBackup,acc = _this$state.acc;

      if (collapsed || !text || !_this.hidden) {
        return (
          _react2.default.createElement('div', null,
            _react2.default.createElement('span', null, text),
            _this.overflow && collapsed && showHideButton &&
            _react2.default.createElement('button', { key: 'moreButton', onClick: _this.closeAllText },
              hideButtonText)));




      }

      var content = withTextEllipses && !collapsed ? accBackup.trim() + '...' : accBackup.trim();

      return (
        _react2.default.createElement('span', { style: { maxHeight: collapsed ? 'auto' : heightLimit + 'px' } },
          _this.overflow ? content : acc.trim(),
          _this.overflow && !collapsed && _react2.default.createElement('span', null, '\xA0'),
          _this.overflow && !collapsed && !hideMoreButton &&
          _react2.default.createElement('button', { key: 'moreButton', onClick: _this.openAllText },
            moreButtonText, !withoutEllipses ? '...' : '')));




    }, _temp), _possibleConstructorReturn(_this, _ret);}ShowMore.prototype.componentDidMount = function componentDidMount() {this.calcOptimizedText(this.props.text);};ShowMore.prototype.componentWillReceiveProps = function componentWillReceiveProps(_ref) {var text = _ref.text;if (text !== this.props.text) {this.calcOptimizedText(text);}};ShowMore.prototype.

  render = function render() {var _cx,_this2 = this;
    return (
      _react2.default.createElement('div', {
          className: (0, _classnames2.default)(this.props.customStyles ? this.props.customStyles : '', _ShowMore2.default.showMoreWrapper, _ShowMore2.default.className, (_cx = {}, _cx[
          _ShowMore2.default.collapsed] = this.state && this.state.collapsed, _cx)) },


        _react2.default.createElement('pre', { ref: function ref(hidden) {_this2.hidden = hidden;}, className: _ShowMore2.default.hidden }),

        _react2.default.createElement('pre', null,
          this.renderText()),

        !!this.props.translateButton && this.renderTranslateButton()));


  };return ShowMore;}(_react.Component);exports.default = ShowMore;


ShowMore.propTypes = {
  text: _propTypes2.default.string,
  moreButtonText: _propTypes2.default.func,
  hideButtonText: _propTypes2.default.func,
  heightLimit: _propTypes2.default.number,
  hideMoreButton: _propTypes2.default.bool,
  showHideButton: _propTypes2.default.bool,
  withoutEllipses: _propTypes2.default.bool,
  customStyles: _propTypes2.default.string,
  withTextEllipses: _propTypes2.default.bool,
  translateButton: _propTypes2.default.node };


ShowMore.defaultProps = {
  heightLimit: 125 };module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/ShowMore/ShowMore.js
// module id = 2909
// module chunks = 0